import React from 'react';
import {
    Box,
    Button,
    HStack,
    Radio,
    RadioGroup,
    Stack,
    Text,
    Image,
} from '@chakra-ui/react';
import { useRef, useState } from 'react';
import CustomDropDown from '@/utils/customDropDown';


const REVIEW_SORT = [
    {
        label: 'Preferred',
        value:'true'
    },
    {
        label: 'Most Recent',
        value:'false'
    }
]

export default function SortByDropDown({
    isFiltersDisabled,
    sortValue='true',
    onSortOptionsChange,
}: any) {
    const sortButtonRef = useRef<HTMLDivElement>(null);
    const [isDropDownOpen, setIsDropDownOpen] = useState<boolean>(false);

    const handleClickOutside = (event: any) => {
        if (sortButtonRef.current?.contains(event.target)) return;
        setIsDropDownOpen(false);
    };

    const handleDropdown = () => {
        setIsDropDownOpen(!isDropDownOpen);
    };

    const getLabelByValue = (val:boolean) => {
        return REVIEW_SORT.find((srotItem:any) => srotItem.value === val)?.label
    }

    return (
        <>
            <Box
                className={
                    isFiltersDisabled
                        ? 'search-sort-dropdown-box search-box-disabled'
                        : 'search-sort-dropdown-box'
                }
                sx={{minWidth:'155px', height: '40px'}}
                ref={sortButtonRef}
                cursor={'pointer'}
            >
                <HStack onClick={handleDropdown} className='search-sort-dropdown' sx={{width: '100%'}}>
                    <Text fontSize={'18px'} lineHeight={'21.6px'} sx={{flexGrow: 1}}>
                        {isFiltersDisabled
                            ? 'Sort By'
                            : getLabelByValue(sortValue)}
                    </Text>
                    <Button
                        size={'sm'}
                        backgroundColor={'#FFFFFF'}
                        className="search-custom-dropdown-button"
                    >
                        <Image src={`/images/ui/${isDropDownOpen ? 'upArrow.svg' : 'downArrow.svg'}`} width={'16px'} height={'16px'} alt="sort icon" />
                    </Button>
                </HStack>
                <HStack onClick={handleDropdown} className='m-search-sort-dropdown'>
                    <Image src="/images/ui/sort.svg" width="24" height="24" alt="sort icon" />
                </HStack>
                {isDropDownOpen && (
                    <CustomDropDown
                        className="sort-dropdown min-w-155"
                        children={
                            <DropDownChild
                                isDisabled={isFiltersDisabled}
                                sortParams={sortValue}
                                onSortOptionsChange={onSortOptionsChange}
                            />
                        }
                        handleClickOutside={handleClickOutside}
                    />
                )}
            </Box>
        </>
    );
}

function DropDownChild({
    isDisabled,
    sortParams,
    onSortOptionsChange,
}: any) {
    function handleSortBy(item: string) {
        onSortOptionsChange(item);
    }
    return (
        <div style={{ padding: '10px' }}>
            <Box>
                <RadioGroup
                    onChange={handleSortBy}
                    value={sortParams || 'true'}
                >
                    <Stack direction="column">
                        {REVIEW_SORT.map((item: any) => (
                            <Box
                                _hover={{ color: '#0090C6' }}
                                className={
                                    isDisabled ? 'search-box-disabled' : ''
                                }
                            >
                                <Radio value={item.value}>{item.label}</Radio>
                            </Box>
                        ))}
                    </Stack>
                </RadioGroup>
            </Box>
        </div>
    );
}
